import { useDisclosure } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { releaseNotesInstance } from '@/modules/releaseNotes'
import { ClientType } from '@/modules/shared/schemas/ClientType'

import ReleaseNotes from '../pages/ReleaseNotes'
import { useAuthContext } from './AuthContext'

const clientType = ClientType.enum.FE

export default function ReleaseNotesProvider({
  children
}: {
  children: React.ReactNode
}) {
  const { userSession, personaSession } = useAuthContext()

  const { isOpen, onOpen, onClose } = useDisclosure()

  const userId = userSession?.userId

  const [versionMajor, versionMinor] = __APP_VERSION__.split('.')

  const releaseNotesQuery = useQuery({
    queryKey: ['releaseNotes', versionMajor, versionMinor, clientType],
    queryFn: async () =>
      await releaseNotesInstance.getReleaseNotes({
        clientType,
        versionMajorNumber: Number(versionMajor),
        versionMinorNumber: Number(versionMinor)
      }),
    initialData: [],
    enabled: !!userId && !!personaSession?.personaId
  })

  useEffect(() => {
    if (!releaseNotesQuery.data.length) return
    onOpen()
  }, [releaseNotesQuery.data])

  return (
    <>
      {releaseNotesQuery.data.length > 0 && (
        <ReleaseNotes
          isOpen={isOpen}
          onClose={onClose}
          data={releaseNotesQuery.data}
        />
      )}
      {children}
    </>
  )
}
